<!-- 
  * @Author: zql
  * @Date: 2025/3/7 14:42
 -->

<template>
    <!-- 65为弹窗header+body(pt+pb)的高度 -->
    <div class="content-wrap" style="height: calc(90vh - 65px);overflow:hidden;" v-loading="fullscreenLoading">
        <div class="tool-bar clearfix">
            <div class="fl">
                <div class="time-zone">
                    <el-select v-model="formItem.time_zone" placeholder="请选择" @change="changeTimeZone" style="width: 106px;" size="mini">
                        <el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>
                        <el-option label="时区-UTC" value="UTC">时区-UTC</el-option>
                    </el-select>
                    <!--Hungry客户：近7天、近30天、近90天（不要今天） -->
                    <el-button-group class="ml6" v-if="isHungryAccount">
                        <template v-if="formItem.date_type=='day'">
                            <el-button :type="isYesTd?'primary':''" @click="quickSelect('yesTd')" size="mini" class="quick-date-btn">昨天</el-button>
                            <el-button :type="isLast7?'primary':''" @click="quickSelect('last7')" size="mini" class="quick-date-btn">近7天</el-button>
                            <el-button :type="isLast30?'primary':''" @click="quickSelect('last30')" size="mini" class="quick-date-btn">近30天</el-button>
                            <el-button :type="isLast90?'primary':''" @click="quickSelect('last90')" size="mini" class="quick-date-btn">近90天</el-button>
                        </template>
                        <template v-else>
                            <el-button :type="isToday?'primary':''" @click="quickSelect('today')" size="mini" class="quick-date-btn">今天</el-button>
                            <el-button :type="isYesTd?'primary':''" @click="quickSelect('yesTd')" size="mini" class="quick-date-btn">昨天</el-button>
                            <el-button :type="isLast3?'primary':''" @click="quickSelect('last3')" size="mini" class="quick-date-btn">近3天</el-button>
                        </template>
                    </el-button-group>
                    <el-button-group class="ml6" v-else>
                        <el-button :type="isToday?'primary':''" @click="quickSelect('today')" size="mini" class="quick-date-btn">今天</el-button>
                        <el-button :type="isYesTd?'primary':''" @click="quickSelect('yesTd')" size="mini" class="quick-date-btn">昨天</el-button>
                        <el-button :type="isLast3?'primary':''" @click="quickSelect('last3')" size="mini" class="quick-date-btn">近三天</el-button>
                        <el-button v-if="formItem.date_type=='day'" :type="isLast7?'primary':''" @click="quickSelect('last7')" size="mini" class="quick-date-btn">近七天</el-button>
                    </el-button-group>
                    <el-date-picker
                        size="mini"
                        class="ml6"
                        v-model="formItem.range_time"
                        type="daterange"
                        align="left"
                        value-format="yyyy-MM-dd"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="formItem.date_type=='day'?pickerOptionsDay:pickerOptionsHour"
                        @change="changeRangeTime"
                        :clearable="false"
                        :editable="false"
                        style="width: 220px;top:1px;">
                    </el-date-picker>

                    <el-radio-group v-model="formItem.date_type" @input="changeDateType" size="mini" class="ml10">
                        <el-radio-button label="day">
                            <span class="inline-block" style="width: 40px;">天</span>
                        </el-radio-button>
                        <el-radio-button label="hour" :disabled="fieldType=='apple_promotion_manage_data_search_term'">
                            <span style="">小时
                                  <el-tooltip placement="top">
                                      <div slot="content" style="max-width: 300px;">
                                          <p v-if="fieldType=='apple_promotion_manage_data_search_term'">搜索词暂不支持小时数据</p>
                                            <div class="mb10" v-if="fieldType!='apple_promotion_manage_data_search_term'" >
                                                <p>提示：</p>
                                                  <p>1.{效果数据指标}是对接三方归因平台的数据，若数据有异常可查看已授权的归因平台；</p>
                                                  <p>2.有关效果类分时数据统计方法可以咨询玩咖，用户数据来源可以咨询相应第三方；</p>
                                                  <p>3.部分数据指标暂不支持分时数据查看，如勾选会造成无法顺利展示；</p>
                                            </div>
                                      </div>
                                      <i class="el-icon-question"></i>
                                  </el-tooltip>
                            </span>
                        </el-radio-button>
                    </el-radio-group>

                    <el-select v-if="formItem.date_type=='hour'" v-model="formItem.hour_type" placeholder="请选择" @change="changeHourType" style="width: 120px;" class="ml10" size="mini">
                        <el-option label="分天观测" value="day"></el-option>
                        <el-option label="分指标观测" value="field"></el-option>
                    </el-select>

                    <el-button :type="isShowChart?'primary':'default'" size="mini" class="ml20" @click="toggleChart">趋势图</el-button>
                </div>
            </div>
            <div class="fr">
                <el-button
                    icon="el-icon-s-operation"
                    size="mini"
                    @click="handleShowDefineRow">自定义列</el-button>
                <el-button
                    icon="el-icon-download"
                    size="mini"
                    :loading="exportLoading"
                    @click="handleExport">导出</el-button>
            </div>
        </div>
        <transition-group name="fade" class="container">
            <div class="chart-wrap relative mt10" v-show="isShowChart" key="chart" style="background-color: #999">
                <div class="chart-select absolute clearfix" style="top:0;left: 0;z-index: 9992;">
                    <div class="text-bold mr10 font12px fl" style="line-height: 30px;">趋势图</div>
                    <div class="fl">
                        <template v-if="formItem.date_type=='hour'&&formItem.hour_type=='day'">
                            <ESelect v-model="formItem.single_field" @change="changeChartSingleField" style="width: 165px;" filterable clearable placeholder="选择指标-支持选择1个" size="mini" :key="formItem.date_type+formItem.hour_type" class="full-w remote-select-tags-width">
                                <el-option
                                    v-for="item in chartFieldList"
                                    :key="item.name"
                                    :label="item.display_name"
                                    :value="item.name">
                                </el-option>
                            </ESelect>
                        </template>
                        <template v-else>
                            <ESelect v-model="formItem.fields" @change="changeChartField" style="width: 165px;" filterable clearable :multiple-limit="5" multiple collapse-tags :key="formItem.date_type+formItem.hour_type" placeholder="选择指标-支持选择5个" size="mini" class="full-w remote-select-tags-width">
                                <el-option
                                    v-for="item in chartFieldList"
                                    :key="item.name"
                                    :label="item.display_name"
                                    :value="item.name">
                                </el-option>
                            </ESelect>
                        </template>
                    </div>
                </div>
                <div class="full-chart-icon" @click="fullScreen" v-show="!chartLoading">
                    <span class="icon iconfont icon-jt-quanping_o" title="全屏展示" ></span>
                </div>
                <div v-loading="chartLoading" id="appleDetailChart" style="height: 200px;background-color: #fff;"></div>
            </div>

            <div class="data-wrap mt10" key="table">
                <el-table :data="dataList" style="width: 100%" ref="table" stripe border class="apple-detail-modal-table"
                          :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" :height="tableHeight"
                          v-loading="dataLoading" tooltip-effect="dark" @header-dragend="handleDragEnd">
                    <el-table-column
                        v-for="(column, index) in columns"
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align||'left'"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :key="index"
                        :width="getLocalStorageWidth?.[fieldType]?.[column.name] || column.width || null"
                    >
                        <template slot-scope="scope">
                            <div v-if="column.name=='date'">{{scope.row.date||scope.row.time_interval||'-'}}</div>
                            <div v-else>{{scope.row[column.name]|Millimeter}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </transition-group>
        <div class="tar pt20 pr20 page-bar">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[30,50,100,500]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>


        <!-- 自定义列 -->
        <CustomizeModal
            ref="refcustomizeModal"
            :customList="assignObj"
            :selectList="fieldList"
            :customBtnLoading="customBtnLoading"
            @getCustomList="getCustomList"/>
    </div>
</template>

<script>
    import dateShortcuts from '../components/dateShortcuts';
    import * as echarts from 'echarts';
    import API from '@/api/marketManage/apple/index';
    import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
    import CustomizeModal from '../modal/customizeModal';
    import dayjs from 'dayjs';
    import { cloneDeep } from 'lodash';
    import store from '@/store'

    export default {
        name: "DataDetailModal",
        props:{
            type: String, // 广告系列组：org、广告系列：campaign、广告组：adgroup、关键词：keyword、搜索词：search
            selectList:Array,
            pageFields:Array,
            data:Object,
            query:Object,
            bidAmount:Object,
        },
        components: {
            CustomizeModal,
        },
        data(){
            let _this = this;
            return {
                fullscreenLoading: false,
                formItem:{
                    time_zone:'UTC',
                    range_time:[],
                    date_type:'',
                    hour_type:'day',
                    fields:[],
                    single_field:'',
                },
                pickerOptionsDay:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        dateShortcuts.today,
                        dateShortcuts.yesterday,
                        dateShortcuts.last3,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                        dateShortcuts.last30,
                        dateShortcuts.thisWeek,
                        dateShortcuts.thisMonth,
                        dateShortcuts.thisQuarter,
                    ],
                    disabledDate(time){
                        let pickedDate = _this.pickedDate;
                        if(!pickedDate){
                            return time.getTime() > Date.now();
                        }else{
                            if(time.getTime() > Date.now()) return true;
                            return (time.getTime() > pickedDate.getTime()+1000*60*60*24*364)||(time.getTime() < pickedDate.getTime()-1000*60*60*24*364);
                        }
                    },
                    onPick:({ maxDate, minDate })=>{
                        if(maxDate===null&&!!minDate){
                            _this.pickedDate = minDate
                        }else if(!!maxDate&&!!minDate){
                            // _this.pickedDate = null;
                        }
                    },
                },
                pickerOptionsHour:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        dateShortcuts.today,
                        dateShortcuts.yesterday,
                        dateShortcuts.last3,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                    ],
                    disabledDate(time){
                        let pickedDate = _this.pickedDate;
                        if(!pickedDate){
                            return time.getTime() > Date.now();
                        }else{
                            if(time.getTime() > Date.now()) return true;
                            return (time.getTime() > pickedDate.getTime()+1000*60*60*24*13)||(time.getTime() < pickedDate.getTime()-1000*60*60*24*13);
                        }
                    },
                    onPick:({ maxDate, minDate })=>{
                        if(maxDate===null&&!!minDate){
                            _this.pickedDate = minDate
                        }else if(!!maxDate&&!!minDate){
                            // _this.pickedDate = null;
                        }
                    },
                },
                isShowChart:false,
                charts:null,
                dataLoading: false,  // 表格loading
                chartLoading:false,
                exportLoading:false,
                getLocalStorageWidth:{}, //缓存宽度
                currentPage: 1,
                pageSize: 100,
                total: 0,
                dataList:[],
                pickedDate:null,
                fieldList:[],       //存储自定义指标的值
                columns:[],
                customBtnLoading:false,
                dateCol:{
                    meconfig:{"disable":"true","fixed":"left"},
                    config:{"disable":"true","fixed":"left"},
                    default_check:"1",
                    display_name:"日期时间",
                    label:"日期时间",
                    name:"date",
                    disabled:'true',
                    align:"left",
                    field_type:"1",
                    fixed:"left",
                    no_drag_item:true,
                    no_drop:1,
                    width:190,
                },
                chartData:[],       //用来存放图表数据
                chartColors:[
                    '#296ff7',
                    '#f75945',
                    '#4a90e2',
                    '#003d99',
                    '#f9a663',
                    '#c43d3d',
                    '#6a0dad',
                    '#b57ff2',
                    '#2ecc71',
                    '#a0d8a0',
                    '#e74c3c',
                    '#f2b5b5',
                    '#f1c40f',
                    '#fae46d',
                ],
                currency:'RMB',     // 当前币种
                moneyFields:[       // 金额的字段，写死的字段，后期需维护
                    'local_spend', 'imp_price', 'ecpm', 'cli_price', 'installs_price', 'new_installs_price', 're_installs_price',
                    'sum_cost','keyword_min_price', 'keyword_avg_price', 'keyword_max_price', 'default_min_price', 'default_avg_price',
                    'default_max_price',
                    'min_conversion_price', 'avg_conversion_price', 'max_conversion_price',
                ],
                rateFields:[         // 带率的字段，写死的字段，后期需维护
                    "imp_click_rate",
                    "cli_installs_rate",
                    "imp_installs_rate",
                    "cli_new_rate",
                    "imp_new_rate",
                    "installs_new_rate",
                    "cli_re_rate",
                    "imp_re_rate",
                    "installs_re_rate",
                    "view_installs_new_rate",
                    "view_installs_re_rate",
                    "total_cli_installs_rate",
                    "total_imp_installs_rate",
                    "total_cli_new_rate",
                    "total_imp_new_rate",
                    "total_installs_new_rate",
                    "total_cli_re_rate",
                    "total_imp_re_rate",
                    "total_installs_re_rate"
                ],
                alertModal:null,
                alertTimer:null,
                alertCount:3,
                pageConfig:{
                    "dynamic_day_type": "",
                    "date_type": "",
                },
            }
        },
        computed:{
            isHungryAccount(){
                /* 针对hungry客户特殊处理 */
                return store.state.user.id=='940';
            },
            defaultChartFields(){
                // 支出-local_spend、安装次数（经点击）-installs、平均每次转化费用（经点击）-installs_price
                let defaultList = ['local_spend','installs','installs_price'];
                let allFieldNames = (this.chartFieldList||[]).map(item=>item.name);
                return defaultList.filter(item=>allFieldNames.includes(item));
            },
            dataId(){
                let data = this.data||{};
                if(this.type=='org') return data.org_id||'';
                if(this.type=='campaign') return data.campaign_id||'';
                if(this.type=='adgroup'||this.type=='adGroup') return data.adgroup_id||'';
                if(this.type=='keyword') return data.keyword_id||'';
                if(this.type=='search'||this.type=='search_term'||this.type=='searchTerm') return data.search_term_id||'';
                return '';
            },
            tableHeight(){
                return this.isShowChart?'calc(90vh - 365px)':'calc(90vh - 155px)';
            },
            chartFieldType(){
                // 广告系列组：、广告系列：、广告组：、关键词：
                if(this.type=='org') return 'apple_promotion_manage_charts_org';
                if(this.type=='campaign') return 'apple_promotion_manage_charts_campaign';
                if(this.type=='adgroup'||this.type=='adGroup') return 'apple_promotion_manage_charts_adgroup';
                if(this.type=='keyword') return 'apple_promotion_manage_charts_keyword';
                if(this.type=='search'||this.type=='search_term'||this.type=='searchTerm') return 'apple_promotion_manage_charts_search_term';
                return '';
            },
            fieldType(){
                // 广告系列组：、广告系列：、广告组：、关键词：
                if(this.type=='org') return 'apple_promotion_manage_data_org';
                if(this.type=='campaign') return 'apple_promotion_manage_data_campaign';
                if(this.type=='adgroup'||this.type=='adGroup') return 'apple_promotion_manage_data_adgroup';
                if(this.type=='keyword') return 'apple_promotion_manage_data_keyword';
                if(this.type=='search'||this.type=='search_term'||this.type=='searchTerm') return 'apple_promotion_manage_data_search_term';
                return '';
            },
            apiType(){
                if(this.type=='org')  return 'getFieldDataOrg';
                if(this.type=='campaign') return 'getFieldDataCampaign';
                if(this.type=='adgroup'||this.type=='adGroup') return 'getFieldDataAdGroup';
                if(this.type=='keyword') return 'getFieldDataKeyword';
                if(this.type=='search'||this.type=='search_term'||this.type=='searchTerm') return 'getFieldDataSearchTerm';
                return '';
            },
            defaultFieldList(){
                return (this.selectList||[]).filter(item=>item.field_type=='2');
            },
            chartFieldList(){
                let list = [];
                if(this.bidAmount){
                    list.push({...this.bidAmount})
                }
                let chone_list_pageFields = cloneDeep(this.pageFields)
                chone_list_pageFields.forEach(item=>{
                    if(item['children']) {
                        item['children'].forEach(itemc => {
                            if(itemc.field_type=='2'){
                                list.push({...itemc});
                            }
                        })
                    }
                });
                return list;
            },
            assignObj() {
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_pageFields = chone_list_pageFields.map(item=>{
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                });

                let baselist = {
                    type:'base_',
                    id : "b_1000",
                    name: 'base',
                    display_name: '基础信息',
                    label: '基础信息',
                    isIndeterminate:false,
                    checked:true,
                    disabled:!this.bidAmount,
                    checkedData:[{...this.dateCol}],
                    children: [{...this.dateCol}]
                };
                if(this.bidAmount){
                    baselist.children.push({
                        meconfig:{"disable":"false"},
                        config:{"disable":"true"},
                        default_check:null,
                        display_name:this.bidAmount.display_name,
                        label:this.bidAmount.display_name,
                        name:this.bidAmount.name,
                        disabled:'false',
                        align:"left",
                        field_type:"1",
                        fixed:"",
                        no_drag_item:false,
                        no_drop:0,
                        width:190,
                    })
                }
                return [baselist,...res_pageFields];
            },
            isToday(){
                if(this.formItem.range_time.length<=0) return false;
                let today = dayjs();
                return today.isSame(dayjs(this.formItem.range_time[0]),'day')&&today.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
            isYesTd(){
                let yesTd = dayjs().subtract(1, 'day');
                return yesTd.isSame(dayjs(this.formItem.range_time[0]),'day')&&yesTd.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
            isLast3(){
                let today = dayjs();
                return today.subtract(2, 'day').isSame(dayjs(this.formItem.range_time[0]),'day')&&today.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
            isLast7(){
                let today = dayjs();
                return today.subtract(6, 'day').isSame(dayjs(this.formItem.range_time[0]),'day')&&today.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
            isLast30(){
                let today = dayjs();
                return today.subtract(29, 'day').isSame(dayjs(this.formItem.range_time[0]),'day')&&today.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
            isLast90(){
                let today = dayjs();
                return today.subtract(89, 'day').isSame(dayjs(this.formItem.range_time[0]),'day')&&today.isSame(dayjs(this.formItem.range_time[1]),'day');
            },
        },
        filters:{
            Millimeter(val){
                if(!val) return val;
                if(val.includes('%')) return val;
                if(isNaN(val)||(val+'')==='NaN') return val;
                if(typeof (+val)==='number'){
                    const intPart = Math.trunc(val);
                    // 整数部分处理，增加,
                    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
                    // 预定义小数部分
                    let floatPart = '';
                    // 将数值截取为小数部分和整数部分
                    const valueArray = val.toString().split('.');
                    if (valueArray.length === 2) { // 有小数部分
                        floatPart = valueArray[1].toString();   // 取得小数部分

                        return (val<0&&val>-1?'-':'') + intPartFormat + '.' + floatPart;
                    }
                    return intPartFormat + floatPart;
                }else{
                    return val;
                }
            },
        },
        created(){
            this.getLocalStorageWidth = getStorage('localStorage','tableWidthMap') || {};
        },
        async mounted(){
            console.log('bidAmount',this.bidAmount);
            let queryData = this.query||{};
            this.formItem.time_zone = queryData.time_zone||'UTC';
            this.chartLoading = true;
            this.dataLoading = true;

            await this.getPageConfig();



            let startDate = queryData.range_time[0];
            let endDate = queryData.range_time[1];

            let isHasConfig = this.pageConfig.date_type||this.pageConfig.dynamic_day_type;

            if(!isHasConfig&&this.formItem.date_type=='day'&&dayjs(startDate).isBefore(dayjs(endDate).subtract(364, 'day'))){
                this.alertModal = this.$alert('分天数据最多可查看356天跨度的数据，系统自动将日期修改为近一年数据，可修改~', '提示', {
                    customClass:'apple-detail-data-modal-alert',
                    confirmButtonText: '确定',
                    callback: async () => {
                        this.$set(this.formItem,'range_time',[dayjs().subtract(364,'day').format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')]);
                        await this.getCustomField();
                        this.getData();
                        window.addEventListener("resize", this.resizeChart);
                    }
                });
                this.startTimer();
            }else if(!isHasConfig&&this.formItem.date_type=='hour'&&dayjs(startDate).isBefore(dayjs(endDate).subtract(364, 'day'))){
                this.alertModal = this.$alert('分时数据最多可查看14天跨度的数据，系统自动将日期修改为近14天', '提示', {
                    customClass:'apple-detail-data-modal-alert',
                    confirmButtonText: '确定',
                    callback: async () => {
                        this.$set(this.formItem,'range_time',[dayjs().subtract(13,'day').format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')]);
                        await this.getCustomField();
                        this.getData();
                        window.addEventListener("resize", this.resizeChart);
                    }
                });
                this.startTimer();
            }else{
                // if(this.pageConfig.date_type||this.pageConfig.dynamic_day_type){
                //     let dateConfig = this.pageConfig.dynamic_day_type;
                //     let today = dayjs().format('YYYY-MM-DD');
                //     if(dateConfig=='0'){
                //         this.formItem.range_time = [today,today];
                //     }else if(dateConfig=='1'){
                //         let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                //         this.formItem.range_time = [yesTd,yesTd];
                //     }else if(dateConfig=='3'){
                //         let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                //         this.formItem.range_time = [last3,today];
                //     }else if(dateConfig=='7'){
                //         let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                //         this.formItem.range_time = [last7,today];
                //     }else{
                //         this.formItem.range_time = queryData.range_time||[];
                //     }
                // }else{
                //     this.formItem.range_time = queryData.range_time||[];
                // }
                await this.getCustomField();
                this.getData();
                window.addEventListener("resize", this.resizeChart);
            }
        },
        methods:{
            async getPageConfig(){
                let queryData = this.query||{};
                await API.getPageConfig({
                    from_page:this.chartFieldType,
                }).then(res=>{
                    let resData = res.data||{};
                    console.log('getPageConfig',res);
                    if(!Array.isArray(resData)&&(resData.dynamic_day_type||resData.date_type)){
                        this.pageConfig = {
                            dynamic_day_type:resData.dynamic_day_type,
                            date_type:resData.date_type,
                        };
                    }
                    this.formItem.date_type = resData.date_type||'day';
                    let today = dayjs().format('YYYY-MM-DD');
                    if(this.pageConfig.dynamic_day_type){
                        let dateConfig = this.pageConfig.dynamic_day_type;
                        if(dateConfig=='0'){
                            this.formItem.range_time = [today,today];
                        }else if(dateConfig=='1'){
                            let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                            this.formItem.range_time = [yesTd,yesTd];
                        }else if(dateConfig=='3'){
                            let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                            this.formItem.range_time = [last3,today];
                        }else if(dateConfig=='7'){
                            let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                            this.formItem.range_time = [last7,today];
                        }else if(dateConfig=='30'){
                            let last30 = dayjs().subtract(29,'day').format('YYYY-MM-DD');
                            this.formItem.range_time = [last30,today];
                        }else if(dateConfig=='90'){
                            let last90 = dayjs().subtract(89,'day').format('YYYY-MM-DD');
                            this.formItem.range_time = [last90,today];
                        }else{
                            this.formItem.range_time = queryData.range_time||[];
                        }
                    }else{
                        this.formItem.range_time = [today,today];
                    }
                },err=>{
                    console.log('getPageConfig',err);
                    this.formItem.date_type = 'day';
                });
            },
            quickSelect(val){
                let today = dayjs().format('YYYY-MM-DD');
                let range = [];
                if(val=='today') {
                    range = [today,today];
                }else if(val=='yesTd'){
                    let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                    range = [yesTd,yesTd];
                }else if(val=='last3'){
                    let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                    range = [last3,today];
                }else if(val=='last7'){
                    let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                    range = [last7,today];
                }else if(val=='last30'){
                    let last30 = dayjs().subtract(29,'day').format('YYYY-MM-DD');
                    range = [last30,today];
                }else if(val=='last90'){
                    let last90 = dayjs().subtract(89,'day').format('YYYY-MM-DD');
                    range = [last90,today];
                }
                this.formItem.range_time = range;
                let typeMap = {
                    today:0,
                    yesTd:1,
                    last3:3,
                    last7:7,
                    last30:30,
                    last90:90,
                };
                API.editPageConfig({
                    from_page:this.chartFieldType,
                    user_data:{
                        dynamic_day_type:typeMap[val],
                        date_type:this.formItem.date_type,
                    }
                });
                this.changeRangeTime();
            },
            async getCustomField(){
                await API.getCustomField({
                    field_type:this.fieldType,
                }).then(res=>{
                    let resData = res.data;
                    if(Array.isArray(res.data)){
                        if(resData.length>0){
                            // 保存过数据，用返回的数据
                            if(resData.map(item=>item.name).includes('date')){
                                this.fieldList = [...resData];
                            }else{
                                this.fieldList = [{...this.dateCol},...resData];
                            }
                        }else{
                            // 最初状态，未保存过值，为空数组，用列表默认数据
                            this.fieldList = [{...this.dateCol},...this.defaultFieldList];
                        }
                    }else{
                        let isSet = (resData||{}).isset||'';
                        if(isSet){
                            // 保存的就是空[]，展示空
                            this.fieldList = [{...this.dateCol}];
                        }else{
                            // this.fieldList = [{...this.dateCol},...this.defaultFieldList];
                            this.fieldList = [{...this.dateCol}];
                        }
                    }
                    this.columns = this.fieldList.map(item=>{
                        return {...item};
                    })
                });
                await API.getCustomField({
                    field_type:this.chartFieldType+'_5',
                }).then(res=>{
                    let resData = res.data;
                    if(Array.isArray(res.data)){
                        if(resData.length>0){
                            // 保存过数据，用返回的数据
                            this.formItem.fields = resData;
                        }else{
                            // 最初状态，未保存过值，为空数组，用列表默认数据
                            this.formItem.fields = [...this.defaultChartFields];
                        }
                    }else{
                        let isSet = (resData||{}).isset||'';
                        if(isSet){
                            // 保存的就是空[]，展示空
                            this.formItem.fields = [];
                        }else{
                            this.formItem.fields = [];
                        }
                    }
                });
                await API.getCustomField({
                    field_type:this.chartFieldType+'_1',
                }).then(res=>{
                    let resData = res.data;
                    if(Array.isArray(res.data)){
                        if(resData.length>0){
                            // 保存过数据，用返回的数据
                            this.formItem.single_field = resData[0]||'';
                        }else{
                            // 最初状态，未保存过值，为空数组，用列表默认数据
                            this.formItem.single_field = this.formItem.fields[0]||this.defaultChartFields[0]||'';
                        }
                    }else{
                        let isSet = (resData||{}).isset||'';
                        if(isSet){
                            // 保存的就是空[]，展示空
                            this.formItem.single_field = '';
                        }else{
                            this.formItem.single_field = '';
                        }
                    }
                })
            },
            getData(){
                if(this.isShowChart){
                    this.getChartData();
                }
                this.getTableData();
            },
            getChartData(){
                let fields = [];
                if(this.formItem.date_type=='hour'&&this.formItem.hour_type=='day'){
                    fields = [this.formItem.single_field];
                }else{
                    fields = [...this.formItem.fields];
                }
                let isHourDay = this.formItem.date_type=='hour'&&this.formItem.hour_type=='day';
                let reqData = {
                    id:this.dataId,
                    type: this.formItem.date_type=='day'?'1':this.formItem.hour_type=='day'?'2':'3',        // 1-按天 2-按小时分天观测 3-按小时
                    time_zone:this.formItem.time_zone,
                    range_time:this.formItem.range_time.join('/'),
                    is_table:'1',   // 1-趋势图 2-列表
                };
                if(this.type=='search_term'){
                    reqData.keyword_id = (this.data||{}).keyword_id||'';
                }
                if(fields.filter(item=>!!item).length>0){
                    reqData.fields = isHourDay?fields.splice(0,1):fields;
                }


                this.chartLoading = true;
                API[this.apiType](reqData).then(res => {
                    this.chartLoading = false;
                    let resData = res.data||{};
                    let dataList = resData.list||[];
                    if(dataList.length>0){
                        let keys = Object.keys(dataList[0]);
                        keys.forEach(item=>{
                            if(dataList.map(inner=>inner[item]).some(item=>(item||'').includes('%'))){
                                if(!this.rateFields.includes(item)){
                                    this.rateFields.push(item);
                                }
                            }
                        })
                    }
                    this.chartData = dataList;
                    this.currency = resData.currency;

                    this.initChart();
                }, err=>{
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                            this.loading = false
                        });
                        return
                    }
                    this.chartLoading = false;
                    this.$message.error(err.info||'请求有误');
                })
            },
            getTableData(){
                let fields = this.fieldList.map(item=>item.name).filter(item=>item!='date');
                let reqData = {
                    id:this.dataId,
                    type: this.formItem.date_type=='day'?'1':this.formItem.hour_type=='day'?'2':'3',        // 1-按天 2-按小时分天观测 3-按小时
                    time_zone:this.formItem.time_zone,
                    range_time:this.formItem.range_time.join('/'),
                    fields:fields,
                    is_table:'2',   // 1-趋势图 2-列表
                    pn:this.currentPage,
                    rn:this.pageSize,
                };
                if(this.type=='search_term'){
                    reqData.keyword_id = (this.data||{}).keyword_id||'';
                }
                this.dataLoading = true;
                API[this.apiType](reqData).then(res => {
                    this.dataLoading = false;
                    let resData = res.data||{};
                    this.dataList = resData.list||[];
                    this.total = resData.totalCnt||0;
                    this.currency = resData.currency;
                    this.tableDoLayout();
                }, err=>{
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                            this.loading = false
                        });
                        return
                    }
                    this.dataLoading = false;
                    this.$message.error(err.info||'请求有误');
                })
            },
            changeTimeZone(){
                this.getData();
            },
            changeRangeTime(){
                this.pickedDate = null;

                this.savePageConfig();
                this.getData();
            },
            changeDateType(val){
                if(val=='hour'){
                    this.formItem.hour_type = 'day';
                }
                let startDate = this.formItem.range_time[0];
                let endDate = this.formItem.range_time[1];
                if(val=='hour'&&dayjs(startDate).isBefore(dayjs(endDate).subtract(13, 'day'))){
                    this.alertModal = this.$alert('分时数据最多可查看14天跨度的数据，系统自动将日期修改为近14天，可修改~', '提示', {
                        customClass:'apple-detail-data-modal-alert',
                        confirmButtonText: '确定',
                        callback: (action) => {
                            if(action == 'confirm'){
                                this.$set(this.formItem,'range_time',[dayjs().subtract(13,'day').format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')]);
                                this.getData();
                                this.savePageConfig();
                            }else{
                                this.$nextTick(()=>{
                                    this.formItem.date_type = 'day';
                                })
                            }
                            this.resetTimer();
                        }
                    });
                    this.startTimer();
                }else{
                    this.getData();
                    this.savePageConfig();
                }
            },
            savePageConfig(){
                let range0 = this.formItem.range_time[0]||'';
                let range1 = this.formItem.range_time[1]||'';
                let today = dayjs().format('YYYY-MM-DD');
                let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                let dynamicDayType = '';
                if(dayjs(range0).format('YYYY-MM-DD')==today&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '0';
                }else if(dayjs(range0).format('YYYY-MM-DD')==yesTd&&dayjs(range1).format('YYYY-MM-DD')==yesTd){
                    dynamicDayType = '1';
                }else if(dayjs(range0).format('YYYY-MM-DD')==last3&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '3';
                }else if(dayjs(range0).format('YYYY-MM-DD')==last7&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '7';
                }
                let dateType = this.formItem.date_type;
                API.editPageConfig({
                    from_page:this.chartFieldType,
                    user_data:{
                        dynamic_day_type:dateType=='hour'&&dynamicDayType=='7'?'':dynamicDayType,
                        date_type:dateType,
                    }
                });

            },
            startTimer(){
                if(this.alertTimer) clearInterval(this.alertTimer);
                this.alertCount = 3;
                this.alertTimer = setInterval(()=>{
                    // let $modal = document.querySelector('.apple-detail-data-modal-alert');
                    // if($modal){
                    //     let $button = $modal.querySelector('.el-message-box__btns button.el-button');
                    //     if($button){
                    //         $button.innerHTML = this.alertCount>0?'<span>确定（'+(this.alertCount)+'s）</span>':'<span>确定</span>'
                    //     }
                    // }
                    if(this.alertCount<=0){
                        let $modal = document.querySelector('.apple-detail-data-modal-alert');
                        if($modal){
                            let $button = $modal.querySelector('.el-message-box__btns button.el-button');
                            if($button){
                                $button.click();
                            }
                            clearInterval(this.alertTimer);
                            this.alertTimer = null;
                            this.alertCount = 3;
                        }
                    }else{
                        this.alertCount = this.alertCount-1;
                    }
                },1*1000)
            },
            resetTimer(){
                clearInterval(this.alertTimer);
                this.alertTimer = null;
                this.alertCount = 3;
                this.alertModal = null;
            },
            changeHourType(){
                this.getData();
            },
            toggleChart(){
                this.isShowChart = !this.isShowChart;
                if(this.isShowChart){
                    this.getChartData();
                }
            },
            changeChartSingleField(){
                this.getChartData();
                this.setChartFields('_1');
            },
            changeChartField(){
                this.getChartData();
                this.setChartFields('_5');
            },
            // 获取自定义列
            setChartFields(val) {
                let fields = [];
                if(this.formItem.date_type=='hour'&&this.formItem.hour_type=='day'){
                    fields = [this.formItem.single_field];
                }else{
                    fields = [...this.formItem.fields];
                }
                API.setCustomField({
                    field_type: this.chartFieldType+val,
                    fields: fields,
                })
            },
            initChart(){
                let _this = this;
                let $chart = document.getElementById('appleDetailChart');
                if(!$chart) return;

                if(!this.charts){
                    this.charts = echarts.init($chart);
                }
                let option = {};

                if(this.formItem.date_type=='day'){
                    // 按天
                    let fieldList = this.formItem.fields.map(item=>{
                        let actionItem = this.chartFieldList.find(inner=>inner.name==item)||{};
                        return {...actionItem}
                    });
                    let legendData = fieldList.map(item=>item.display_name);

                    option = {
                        backgroundColor:'#fff',
                        color:this.chartColors,
                        tooltip: {
                            trigger: 'axis',
                            appendToBody:false,
                            formatter:(params)=>{
                                let name = params[0].name;
                                let dataStr = '';
                                params.forEach(item=>{
                                    let fieldItem = _this.chartFieldList.find(inner=>inner.display_name==item.seriesName);
                                    let isRate = _this.rateFields.includes(fieldItem.name);
                                    let moneyStr = '';
                                    let isMoneyField = _this.moneyFields.includes(fieldItem.name);
                                    if(fieldItem&&_this.moneyFields.includes(fieldItem.name)){
                                        if(item.data&&item.data!='-'&&item.data!='NaN'){
                                            moneyStr = _this.currency=='RMB'||_this.currency=='元'?'￥':'$';
                                        }
                                    }
                                    if(isRate){
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+this.formatNumberWithCommas(item.data*100,'%')+'</span></p>';
                                    }else{
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+moneyStr+this.formatNumberWithCommas(item.data,'',isMoneyField&&moneyStr=='$')+'</span></p>';
                                    }
                                });
                                return `<p style="font-weight: bold;">${name}</p>`+dataStr;
                            },
                            confine: true,  // 将tooltip限制在该容器内
                        },
                        legend: {
                            data: legendData,
                        },
                        xAxis: {
                            type: 'category',
                            data: (this.chartData||[]).map(item=>{
                                return dayjs(item.date).format('YYYY/MM/DD')
                            }),
                            axisTick:{
                                show:false,
                            }
                        },
                        yAxis: {
                            type: 'value'
                        },
                        grid:{
                            left: '3%',
                            right: '4%',
                            bottom: '10%',
                            top:'60',
                            containLabel: true,
                        },
                        series: fieldList.map(item=>{
                            return  {
                                name:item.display_name,
                                data: this.chartData.map(inner=>{
                                    let val = this.formatNumber(inner[item.name]);
                                    if(this.rateFields.includes(item.name)){
                                        return this.formatRateVal(val);
                                    }else{
                                        return val;
                                    }
                                }),
                                type: 'line',
                                showSymbol: true,
                                symbol:'',
                                symbolSize:2,
                                smooth: true,
                                zlevel:2,
                            }
                        }),
                        dataZoom:[
                            {
                                type: 'slider',
                                xAxisIndex: 0,
                                height:'5%',
                                minSpan: 5,
                                bottom: '4%',
                                show:true,
                            }
                        ],
                    };
                }else if(this.formItem.hour_type=='day'){
                    // 小时-天
                    let firstRow = this.chartData[0]||{};
                    let dateKeys = Object.keys(firstRow).filter(item=>/^\d{4}(\-|\/|\.)\d{1,2}\1\d{1,2}$/g.test(''+item));
                    let fieldItem = this.chartFieldList.find(item=>item.name==this.formItem.single_field)||{};
                    let fieldName = fieldItem.display_name||'';

                    option = {
                        backgroundColor:'#fff',
                        color:this.chartColors,
                        tooltip: {
                            trigger: 'axis',
                            appendToBody:false,
                            height:'50%',
                            confine: true,  // 将tooltip限制在该容器内
                            formatter:(params)=>{
                                let name = params[0].name;
                                let dataStr = '';
                                params.forEach(item=>{
                                    let isRate = _this.rateFields.includes(fieldItem.name);
                                    let moneyStr = '';
                                    let isMoneyField = _this.moneyFields.includes(fieldItem.name);
                                    if(fieldItem&&_this.moneyFields.includes(fieldItem.name)){
                                        if(item.data&&item.data!='-'&&item.data!='NaN'){
                                            moneyStr = _this.currency=='RMB'||_this.currency=='元'?'￥':'$';
                                        }
                                    }
                                    if(isRate){
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+this.formatNumberWithCommas(item.data*100,'%')+'</span></p>';
                                    }else{
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+moneyStr+this.formatNumberWithCommas(item.data,'',isMoneyField&&moneyStr=='$')+'</span></p>';
                                    }


                                });
                                return `<p style="font-weight: bold;">${fieldName}（${name}）</p>`+dataStr;
                            },
                        },
                        legend: {
                            width: '60%',
                            data: dateKeys,
                        },
                        xAxis: {
                            type: 'category',
                            data: (this.chartData||[]).map(item=>{
                                return item.time_interval||item.date;
                            }),
                            axisTick:{
                                show:false,
                            }
                        },
                        yAxis: {
                            type: 'value'
                        },
                        grid:{
                            left: '3%',
                            right: '4%',
                            bottom: '10%',
                            top:'60',
                            containLabel: true,
                        },
                        series: dateKeys.map(item=>{
                            return  {
                                name:item,
                                data: this.chartData.map(inner=>{
                                    let val = this.formatNumber(inner[item]);
                                    if(this.rateFields.includes(item)){
                                        return this.formatRateVal(val);
                                    }else{
                                        return val;
                                    }
                                }),
                                type: 'line',
                                showSymbol: true,
                                symbol:'',
                                symbolSize:2,
                                smooth: true,
                                zlevel:2,
                            }
                        }),
                        dataZoom:[
                            {
                                type: 'slider',
                                xAxisIndex: 0,
                                height:'5%',
                                minSpan: 5,
                                bottom: '4%',
                                show:true,
                            }
                        ],
                    };
                }else{
                    // 小时-分指标
                    let fieldList = this.formItem.fields.map(item=>{
                        let actionItem = this.chartFieldList.find(inner=>inner.name==item)||{};
                        return {...actionItem}
                    });
                    let legendData = fieldList.map(item=>item.display_name);
                    let rangeStr = this.formItem.range_time.map(item=>dayjs(item).format('YYYY/MM/DD')).join('-');

                    option = {
                        backgroundColor:'#fff',
                        color:this.chartColors,
                        tooltip: {
                            trigger: 'axis',
                            appendToBody:false,
                            formatter:(params)=>{
                                let name = params[0].name;
                                let dataStr = '';
                                params.forEach(item=>{
                                    let fieldItem = _this.chartFieldList.find(inner=>inner.display_name==item.seriesName);
                                    let isRate = _this.rateFields.includes(fieldItem.name);
                                    let moneyStr = '';
                                    let isMoneyField = _this.moneyFields.includes(fieldItem.name);
                                    if(fieldItem&&_this.moneyFields.includes(fieldItem.name)){
                                        if(item.data&&item.data!='-'&&item.data!='NaN'){
                                            moneyStr = _this.currency=='RMB'||_this.currency=='元'?'￥':'$';
                                        }
                                    }

                                    if(isRate){
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+this.formatNumberWithCommas(item.data*100,'%')+'</span></p>';
                                    }else{
                                        dataStr += '<p class="clear-fix"><span class="fl">'+item.seriesName+'：</span><span class="fr">'+moneyStr+this.formatNumberWithCommas(item.data,'',isMoneyField&&moneyStr=='$')+'</span></p>';
                                    }
                                });
                                return `<p style="font-weight: bold">${name}（${rangeStr}）</p>`+dataStr;
                            },
                            confine: true,  // 将tooltip限制在该容器内
                        },
                        legend: {
                            data: legendData,
                        },
                        xAxis: {
                            type: 'category',
                            data: (this.chartData||[]).map(item=>{
                                return item.time_interval||item.date;
                            }),
                            axisTick:{
                                show:false,
                            }
                        },
                        yAxis: {
                            type: 'value'
                        },
                        grid:{
                            left: '3%',
                            right: '4%',
                            bottom: '10%',
                            top:'60',
                            containLabel: true,
                        },
                        series: fieldList.map(item=>{
                            return  {
                                name:item.display_name,
                                data: this.chartData.map(inner=>{
                                    let val = this.formatNumber(inner[item.name]);
                                    if(this.rateFields.includes(item.name)){
                                        return this.formatRateVal(val);
                                    }else{
                                        return val;
                                    }
                                }),
                                type: 'line',
                                showSymbol: true,
                                symbol:'',
                                symbolSize:2,
                                smooth: true,
                                zlevel:2,
                            }
                        }),
                        dataZoom:[
                            {
                                type: 'slider',
                                xAxisIndex: 0,
                                height:'5%',
                                minSpan: 5,
                                bottom: '4%',
                                show:true,
                            }
                        ],
                    };
                }

                this.charts.setOption(option,true);
            },
            resizeChart(){
                let $chart = this.charts;
                $chart&&$chart.resize();
            },
            // 每页条数
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getTableData()
            },
            // 当前页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getTableData()
            },
            // fullScreen(){
            //     const element = document.getElementById('appleDetailChart');
            //     if(!element) return;
            //     // IE 10及以下ActiveXObject
            //     if (window.ActiveXObject) {
            //         const WsShell = new ActiveXObject('WScript.Shell');
            //         WsShell.SendKeys('{F11}');
            //     } else if (element.requestFullScreen) { // HTML W3C 提议
            //         element.requestFullScreen();
            //     } else if (element.msRequestFullscreen) { // IE11
            //         element.msRequestFullScreen();
            //     } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
            //         element.webkitRequestFullScreen();
            //     } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
            //         element.mozRequestFullScreen();
            //     }
            // },
            fullScreen(){
                const element = document.getElementById('appleDetailChart');
                if(!element) return;
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                const handleFullScreenChange = () => {
                    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitfullscreenchange) {
                        // 添加延迟确保 Safari 正确计算高度
                        console.log('进入全屏', isSafari);
                        if(isSafari) {
                            // this.chartLoading = true;
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    if (this.charts) {
                                        // 强制重新计算容器高度
                                        const container = document.getElementById('appleDetailChart');
                                        if (container) {
                                            container.style.height = '100%';
                                        }
                                        this.charts.resize();
                                        // this.chartLoading = false
                                    }
                                });
                            }, 100); // 100ms 延迟
                        }else{
                            this.charts.resize();
                        }

                    } else {
                        // 关闭全屏时设置宽度为200px
                        const container = document.getElementById('appleDetailChart');
                        if (isSafari && container) {
                            this.fullscreenLoading = true;
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    if (this.charts) {
                                        // 强制重新计算容器高度
                                        const container = document.getElementById('appleDetailChart');
                                        if (container) {
                                            container.style.height = '200px';
                                        }
                                        this.charts.resize();
                                        setTimeout(()=>{this.fullscreenLoading = false;},1000)
                                    }
                                });
                            }, 0);
                        }else{
                            this.charts.resize();
                        }
                    }
                };

                // 添加全屏事件监听
                document.addEventListener('fullscreenchange', handleFullScreenChange);
                document.addEventListener('webkitfullscreenchange', handleFullScreenChange);
                document.addEventListener('mozfullscreenchange', handleFullScreenChange);
                document.addEventListener('MSFullscreenChange', handleFullScreenChange);

                // IE 10及以下ActiveXObject
                if (window.ActiveXObject) {
                    const WsShell = new ActiveXObject('WScript.Shell');
                    WsShell.SendKeys('{F11}');
                } else if (element.requestFullScreen) { // HTML W3C 提议
                    element.requestFullScreen();
                } else if (element.msRequestFullscreen) { // IE11
                    element.msRequestFullScreen();
                } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                    element.mozRequestFullScreen();
                }
            },
            handleShowDefineRow(){
                this.$refs.refcustomizeModal.showModal();
            },
            handleExport(){
                this.exportLoading = true;
                let fields = this.fieldList.map(item=>item.name).filter(item=>item!='date');
                let reqData = {
                    id:this.dataId,
                    type: this.formItem.date_type=='day'?'1':this.formItem.hour_type=='day'?'2':'3',        // 1-按天 2-按小时分天观测 3-按小时
                    time_zone:this.formItem.time_zone,
                    range_time:this.formItem.range_time.join('/'),
                    fields:fields,
                    is_table:'2',   // 1-趋势图 2-列表
                    export:'1',
                };
                if(this.type=='search_term'){
                    reqData.keyword_id = (this.data||{}).keyword_id||'';
                }
                API[this.apiType](reqData).then(res => {
                    this.exportLoading = false;
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {});
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            handleDragEnd(newWidth, oldWidth, column) {
                let getCurrentNameWidth = this.getLocalStorageWidth[this.fieldType] || {}
                //存储示例格式 {address: 707, date: 184, name: 246}
                let result = Object.assign(getCurrentNameWidth, {
                    [column.property]: parseInt(newWidth),
                });
                setStorage('localStorage', 'tableWidthMap', Object.assign({},this.getLocalStorageWidth,{
                    [this.fieldType]: result
                }) );
                this.tableDoLayout();
            },
            tableDoLayout(){
                this.$nextTick(()=>{
                    let $table = this.$refs.table;
                    $table&&$table.doLayout();
                })
            },
            // 获取自定义列
            getCustomList(values) {
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: this.fieldType,
                    fields: values
                }).then(async res => {
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    await this.getCustomField();
                    this.getData();
                }, (err) => {
                    this.customBtnLoading = false;
                    console.log('error', err);
                    this.$message.error(err.info)
                })
            },
            // 千分位处理
            formatNumberWithCommas(val,suffix='',isMoneyField) {
                if(isNaN(val)||val==='NaN') return '-';
                let number = parseFloat(''+val)+'';
                // 仅处理整数部分
                if(number.includes('.')){
                    let numArray = number.split('.');
                    let intStr = (numArray[0]||'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    let dotStr = numArray[1];
                    if(isMoneyField){
                        dotStr = (dotStr+'').padEnd(3,'0').substr(0,3);
                        return ''+intStr+'.'+dotStr;
                    }else{
                        dotStr = (dotStr+'').substr(0,2);
                        return ''+intStr+'.'+dotStr+suffix;
                    }
                }else{
                    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",")+suffix;
                }
            },
            // 千分位处理
            formatNumber(val) {
                if(Number.isNaN(val)) return val;
                return parseFloat(''+val)+'';
            },
            // 45.67%->0.45
            formatRateVal(val){
                if(Number.isNaN(val)) return val;
                let str = (val+'').replace("%","");
                return str/100;
            },
        },
        beforeDestroy(){
            // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
            let $chart = this.charts;
            $chart&&$chart.dispose();

            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>
    .container {
        position: relative;
        padding: 0;
        list-style-type: none;
    }
    /* 1. 声明过渡效果 */
    .fade-move,
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    }

    /* 2. 声明进入和离开的状态 */
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
        transform: scaleY(0.01);
    }

    /* 3. 确保离开的项目被移除出了布局流
          以便正确地计算移动时的动画效果。 */
    .fade-leave-active {
        position: absolute;
        opacity: 0;
    }


    .full-chart-icon{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
        z-index: 1;
    }
    .page-bar{
        position: absolute;
        right: 0;
        bottom: 15px;
    }

    ::v-deep .el-loading-mask{
        background-color: rgba(255, 255, 255, 1);
    }
</style>
<style lang="scss">
    .apple-detail-modal-table .el-table__row.hover-row td{
        background-color: rgb(235.9, 245.3, 255)!important;
    }
</style>
